module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/66644f76b3f90ffeeb9bec0ffd4bccdb.jpg";